import { createContext, useState } from "react";
import API from "../api/Api";

export const ProjectContext = createContext(null);

export const ProjectProvider = ({ children }) => {
  const [projectDetails, setProjectDetails] = useState(null);
  const [loadingProject, setLoadingProject] = useState(false);

  const getProjectDetails = async (projectId) => {
    try {
      setLoadingProject(true);
      const res = await API.get(`/projects/${projectId}`);
      console.log("projectId:", projectId);
      setProjectDetails(res.data.data);
      console.log("Fetched Project Details:", res.data.data);
    } catch (err) {
      console.error("Project Details Error:", err);
    } finally {
      setLoadingProject(false);
    }
  };

  return (
    <ProjectContext.Provider
      value={{
        projectDetails,
        loadingProject,
        getProjectDetails
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};
